import React from 'react';
import { isObject, isString, uniqueId } from 'lodash';
import { Icon } from 'ui';

export const ListBlock = ({ header, onEdit, children, options }) => (
  <div className="AssignMobileReview-listBlock">
    <div className="AssignModal-formBlockHeader">
      <span className="AssignModal-subtitle">{header}</span>
      <button
        type="button"
        className="AssignMobileReview-editBtn"
        onClick={onEdit}
      >
        Edit
      </button>
    </div>
    {options || children}
  </div>
);

export const renderOptions = (items, labelKey) => (
  <ul className="AssignMobileReview-selectedItems list-unstyled">
    {isString(items[0]) &&
      items.map((item, i) => (
        <li key={uniqueId()} className="AssignMobileReview-selectedItem">
          {item}
        </li>
      ))}
    {isObject(items[0]) &&
      items.map(({ id, type, ...item }) => (
        <li key={`${type}.${id}`} className="AssignMobileReview-selectedItem">
          {/group/i.test(type) && <Icon name={type.toLowerCase()} />}
          {item[labelKey]}
        </li>
      ))}
  </ul>
);
